import { Component, ElementRef, Input, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { KrampSpecial } from '../kramp-special';
import { SortAccessorMap, SortState, sortItems } from 'src/app/utils/sort-utils';

type KrampSortKey =
  | 'sku'
  | 'description'
  | 'krampSupplierSku'
  | 'krampSpecialCode'
  | 'class4'
  | 'krampSupplier'
  | 'orderUnit'
  | 'supplierPrice'
  | 'salesPrice'
  | 'margin'
  | 'deliveryDays'
  | 'creationBy'
  | 'creationDate';

@Component({
  selector: 'app-kramp-specials-table',
  templateUrl: './kramp-specials-table.component.html',
  styleUrls: ['./kramp-specials-table.component.scss'],
})
export class KrampSpecialsTableComponent {
  @ViewChildren('sortIcons') sortIcons!: QueryList<ElementRef>;
  @Input() specials: KrampSpecial[] = [];
  selectedIds = new Set<number>();
  selectedSpecials: KrampSpecial[] = [];

  page: number = 1;
  searchText: string = '';
  sortState: SortState<KrampSortKey> | null = null;
  sortAccessors: SortAccessorMap<KrampSpecial, KrampSortKey> = {
    sku: special => special.sku,
    description: special => special.description,
    krampSupplierSku: special => special.krampSupplierSku,
    krampSpecialCode: special => special.krampSpecialCode,
    class4: special => special.class4,
    krampSupplier: special => special.krampSupplierName,
    orderUnit: special => special.orderUnit,
    supplierPrice: special => special.supplierPrice,
    salesPrice: special => special.salesPrice,
    margin: special => special.margin,
    deliveryDays: special => special.deliveryDays,
    creationBy: special => special.creationBy,
    creationDate: special => special.creationDate,
  };

  constructor(private renderer: Renderer2) {}

  isSelected(s: KrampSpecial): boolean {
    return this.selectedIds.has(s.id);
  }

  toggleSelection(special: KrampSpecial, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.selectedIds.add(special.id);
      this.selectedSpecials.push(special);
    } else {
      this.selectedIds.delete(special.id);
      this.selectedSpecials = this.selectedSpecials.filter(s => s.id !== special.id);
    }
  }

  getNextAscending(field: KrampSortKey): boolean {
    if (!this.sortState || this.sortState.key !== field) {
      return true;
    }

    return !this.sortState.ascending;
  }

  sortByField(field: KrampSortKey, ascendingOrder: boolean = this.getNextAscending(field)) {
    this.sortState = { key: field, ascending: ascendingOrder };
    this.specials = sortItems(this.specials, field, ascendingOrder, this.sortAccessors);
    this.updateSortingHighlight(`${field}${ascendingOrder ? 'Asc' : 'Desc'}`);
  }

  updateSortingHighlight(highlightElement: string) {
    this.sortIcons.forEach((element: ElementRef) => {
      const nativeElement = element.nativeElement as HTMLElement;
      if (nativeElement.id == highlightElement) {
        this.renderer.addClass(nativeElement, 'highlight');
      } else {
        this.renderer.removeClass(nativeElement, 'highlight');
      }
    });
  }

  onSearchTextChange() {
    this.page = 1;
  }
}
